import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';

const ContractReviewPage = React.lazy(() => import('./review/ContractReviewPage'));

/** The onboarding review route. Legacy layout query parameters are ignored. */
const ContractVersionReviewPage: React.FC = () => {
  const location = useLocation();
  return (
    <Suspense fallback={<p style={{ padding: 24, color: '#b3c2d5' }}>Loading contract review…</p>}>
      <ContractReviewPage key={location.pathname} />
    </Suspense>
  );
};

export default ContractVersionReviewPage;
